/**
 * SectionHeader component - Consistent section titles
 */

import {HTMLAttributes, forwardRef} from 'react';
import {cn} from '../../utils/cn';

interface SectionHeaderProps extends HTMLAttributes<HTMLDivElement> {
  title: string;
  subtitle?: string;
  centered?: boolean;
  size?: 'sm' | 'md' | 'lg';
}

export const SectionHeader = forwardRef<HTMLDivElement, SectionHeaderProps>(
  ({className, title, subtitle, centered = false, size = 'md', ...props}, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          'mb-12 sm:mb-16',
          {
            'text-center': centered,
            'text-left': !centered,
          },
          className
        )}
        {...props}
      >
        <h2
          className={cn(
            'font-heading font-bold text-textPrimary dark:text-[#CCCCCC] mb-4',
            {
              'text-2xl sm:text-3xl lg:text-4xl': size === 'sm',
              'text-3xl sm:text-4xl lg:text-5xl': size === 'md',
              'text-4xl sm:text-5xl lg:text-6xl': size === 'lg',
            }
          )}
        >
          {title}
        </h2>
        {subtitle && (
          <p
            className={cn(
              'text-base sm:text-lg lg:text-xl text-textSecondary dark:text-[#858585] max-w-3xl leading-relaxed',
              {
                'mx-auto': centered,
              }
            )}
          >
            {subtitle}
          </p>
        )}
      </div>
    );
  }
);

SectionHeader.displayName = 'SectionHeader';

